import {
	ApiClientManager,
	SimulationInputDto,
	SimulationOutputDtoSingleOutputMessage,
} from '@api/consumerloans-public-api';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { useLoadingStore, usePTCMetadata, useServicesStore } from '@store';

export const useFetchSimulation = (): UseFetchHookOutput<
	SimulationInputDto,
	SimulationOutputDtoSingleOutputMessage
> => {
	const saveServiceResponse = useServicesStore((state) => state.saveServiceResponse);
	const metadata = usePTCMetadata();
	const applicationContextId = useServicesStore((state) => state.init?.applicationContextId);
	const setIsLoadingSimulation = useLoadingStore((state) => state.setIsLoadingSimulation);

	return useFetch<SimulationInputDto, SimulationOutputDtoSingleOutputMessage>({
		fetchFn: (data: SimulationInputDto) => {
			setIsLoadingSimulation(true);
			return ApiClientManager.call.simulation({ data: { ...data, metadata, applicationContextId } });
		},
		onSuccess: (res: SimulationOutputDtoSingleOutputMessage) => {
			if (res.data) {
				setIsLoadingSimulation(false);
				saveServiceResponse({ simulation: res.data || {} });
			}
		},
		onError: () => {
			setIsLoadingSimulation(false);
		},
		notShowLoading: true,
	});
};
